import { dbuiV1WarehouseListOptions } from '@antimatterhq/asl-api-ts-v1';
import { useQuery } from '@antimatterhq/ui/hooks/queries/useQuery';
import { useWorkspace } from '@/contexts/WorkspaceContext';
import { defaultOptions } from '@/utils/query';

export const useGetWarehouseLocations = () => {
  const { workspace } = useWorkspace();
  return useQuery({
    ...dbuiV1WarehouseListOptions({
      ...defaultOptions(),
      path: { workspace },
    }),
    enabled: !!workspace,
    refetchInterval: 2000,
  });
};
